import React from 'react';

const getScoreColor = (score, passed) => {
  if (passed || score >= 70) return { bg: 'rgba(130,255,207,0.15)', text: 'var(--tqa-green)' };
  if (score >= 50) return { bg: 'rgba(234,179,8,0.15)', text: '#fbbf24' };
  return { bg: 'rgba(239,68,68,0.15)', text: '#f87171' };
};

const timeAgo = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString();
};

const EvalRunList = ({
  runs = [],
  activeRunId,
  onSelectRun,
  selectedRunIds = [],
  onToggleRunSelection,
  onCompare,
  showComparison
}) => {
  const hasMultiple = runs.length >= 2;
  const canCompare = selectedRunIds.length >= 2;

  return (
    <div className="w-64 flex flex-col shrink-0" style={{background:'var(--tqa-surface-2)',borderRight:'1px solid var(--tqa-border-dark)'}}>
      {/* Header */}
      <div className="px-3 py-2.5" style={{borderBottom:'1px solid var(--tqa-border-dark)',background:'var(--tqa-surface)'}}>
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wide" style={{color:'rgba(255,255,255,0.45)'}}>  
            Runs ({runs.length})
          </span>
          {canCompare && (
            <button
              onClick={onCompare}
              className={`px-2 py-0.5 rounded text-[10px] font-medium transition-colors`}
              style={
                showComparison
                  ? { background: 'var(--tqa-green)', color: 'var(--tqa-bg)' }
                  : { background: 'rgba(130, 255, 207, 0.15)', color: 'var(--tqa-green)' }
              }
            >
              Compare ({selectedRunIds.length})
            </button>
          )}
        </div>
        {hasMultiple && !canCompare && (
          <p className="text-[10px] mt-1" style={{color:'rgba(255,255,255,0.35)'}}>Check runs to compare</p>
        )}
      </div>

      {/* Run List */}
      <div className="flex-1 overflow-y-auto">
        {runs.map((run) => {
          const colors = getScoreColor(run.score, run.passed);
          const isActive = activeRunId === run.id && !showComparison;
          const isChecked = selectedRunIds.includes(run.id);

          return (
            <div
              key={run.id}
              className="px-3 py-2.5 cursor-pointer transition-colors border-l-2"
              style={{
                borderLeftColor: isActive ? 'var(--tqa-green)' : 'transparent',
                borderBottom: '1px solid var(--tqa-border-dark)',
                background: isActive ? 'rgba(130, 255, 207, 0.08)' : 'transparent'
              }}
              onMouseEnter={e=>{if(!isActive)e.currentTarget.style.background='rgba(255,255,255,0.04)'}}
              onMouseLeave={e=>{if(!isActive)e.currentTarget.style.background='transparent'}}
              onClick={() => onSelectRun(run.id)}
            >
              <div className="flex items-center gap-2">
                {hasMultiple && (
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                      e.stopPropagation();
                      onToggleRunSelection(run.id);
                    }}
                    onClick={(e) => e.stopPropagation()}
                    className="rounded w-3.5 h-3.5 shrink-0" style={{borderColor:'var(--tqa-border-dark)', accentColor: 'var(--tqa-green)'}}
                  />
                )}
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold`} style={{background: colors.bg, color: colors.text}}>
                  {run.score}%
                </span>
                <span className="text-[11px] ml-auto" style={{color:'rgba(255,255,255,0.35)'}}>{timeAgo(run.createdAt)}</span>
              </div>

              <div className="mt-1.5 flex items-center gap-1 flex-wrap">
                <span className="text-[11px] font-medium truncate max-w-[130px]" style={{color:'rgba(255,255,255,0.7)'}}>  
                  {run.modelDisplayName || run.modelUsed}
                </span>
                {run.thinkingLevel && (
                  <span className="px-1 py-0 rounded text-[9px] font-medium" style={{background:'rgba(130,255,207,0.12)',color:'rgba(130,255,207,0.8)'}}>
                    {run.thinkingLevel}
                  </span>
                )}
              </div>

              <div className="mt-1 flex items-center gap-2 text-[10px]" style={{color:'rgba(255,255,255,0.35)'}}>  
                <span>{(run.durationMs / 1000).toFixed(1)}s</span>
                <span>{run.totalTokens?.toLocaleString()} tok</span>
                {run.estimatedCost > 0 && <span>${parseFloat(run.estimatedCost).toFixed(4)}</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EvalRunList;
